import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
import { logPageView } from '../utils/analyticsEvents';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Tracker chaque changement de page
    const fullPath = location.pathname + location.search;
    trackPageView(fullPath);
    // Log to Firestore for admin dashboard
    logPageView(fullPath);
  }, [location]);

  return null;
}

export default AnalyticsTracker;

